import { useContext } from 'react';
import { AgentInsightsContext, AgentInsightsContextType } from './AgentInsightsContext';

export const useAgentInsightsContext = (): AgentInsightsContextType => {
    const context = useContext(AgentInsightsContext);

    if (!context) {
        throw Error('You are outside of AgentInsightsContextProvider');
    }

    return context;
};
